import { routesUrl } from 'app/fuse-configs/navigationConfig';
import React from 'react';
import { Redirect } from 'react-router-dom';

const MobilePageConfig = {
  settings: {
    layout: {
      config: {
        scroll: 'content',
        navbar: {
          display: false,
        },
        toolbar: {
          display: false,
        },
        footer: {
          display: false,
        },
        mode: 'fullwidth',
      },
    },
    customScrollbars: false,
  },
  routes: [
    { path: routesUrl.mobileHome, exact: true, component: React.lazy(() => import('./home/MobileHomePage')) },
    { path: routesUrl.mobileScanner, exact: true, component: React.lazy(() => import('./scanner/MobileScannerPage')) },
    { path: routesUrl.mobileClients, exact: true, component: React.lazy(() => import('./clients/MobileClientsPage')) },
    {
      path: routesUrl.mobileClientDetail,
      exact: true,
      component: React.lazy(() => import('./clients/MobileClientDetailPage')),
    },
    { path: routesUrl.mobileOffers, exact: true, component: React.lazy(() => import('./offers/MobileOffersPage')) },
    {
      path: routesUrl.mobileCampaigns,
      exact: true,
      component: React.lazy(() => import('./campaigns/MobileCampaignsPage')),
    },
    {
      path: routesUrl.mobileCampaignNew,
      exact: true,
      component: React.lazy(() => import('./campaigns/MobileQuickCampaignPage')),
    },
    { path: '/m', component: () => React.createElement(Redirect, { to: routesUrl.mobileHome }) },
  ],
};

export default MobilePageConfig;
